// extracted by mini-css-extract-plugin
export var body = "_f2-5";
export var closeButton = "_f2-f";
export var container = "_f2-1";
export var content = "_f2-2";
export var cta = "_f2-c";
export var ctaLabel = "_f2-b";
export var eyebrow = "_f2-3";
export var howTo = "_f2-6";
export var image = "_f2-e";
export var modal = "_f2-0";
export var socialButton = "_f2-d";
export var stepCard = "_f2-8";
export var stepLabel = "_f2-a";
export var stepNumber = "_f2-9";
export var steps = "_f2-7";
export var title = "_f2-4";